module.exports = __webpack_public_path__ + "media/images/partners/uddm-6585bcb6e21f1b57abed41d18a965cb9.png";